export enum CustomerRoles {
	customer = 'customer',
}
